module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av710-b539a59675e6325ace1f7414fd8f5ce4.jpg";